import { SetStateAction } from 'react';

//  this fixes any "bad set state call" inside another setState call
export function safeStateUpdate(updater: () => void): void {
  setTimeout(updater, 0);
}

/**
 * Resolution wrapper to custom setter usages
 *
 * @param updateRef The state update reference (action or direct value)
 * @param currentValue The current value inside the state
 * @returns The new state value
 *
 * Substitutes this logic everywhere:
 * @example
 * ```ts
 * const newValue = typeof updater === 'function' ? updater(oldValue) : updater
 * ```
 */
export function resolveSetter<State>(updateRef: SetStateAction<State>, currentValue: State): State {
  return typeof updateRef === 'function'
    ? (updateRef as (s: State) => State)(currentValue)
    : updateRef;
}
